module.exports = __webpack_public_path__ + "img/safety-glasses-no.8eadfa8a.svg";